import { useCallback, useEffect, useState } from 'react';
import { isIPad13, isMobileSafari, isSafari } from 'react-device-detect';
import isStandalone from 'pwa/helpers/isStandalone';
import shouldShowInstallHint from 'pwa/helpers/shouldShowInstallHint';

export const DISMISSED_STORAGE_KEY = 'pwa-install-hint-dismissed';

/**
 * Safari on iOS is the only browser that can add the app to the iOS home
 * screen. Chrome and Firefox on iOS are excluded because their share sheet
 * cannot install a web app, so the instructions would not work there.
 */
const isIosSafari = isMobileSafari || (isIPad13 && isSafari);

interface IosInstallHint {
  isVisible: boolean;
  dismiss: () => void;
}

export default function useIosInstallHint(): IosInstallHint {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(
      shouldShowInstallHint({
        isIosSafari,
        isInStandaloneMode: isStandalone(),
        isDismissed:
          window.localStorage.getItem(DISMISSED_STORAGE_KEY) === 'true',
      })
    );
  }, []);

  const dismiss = useCallback(() => {
    window.localStorage.setItem(DISMISSED_STORAGE_KEY, 'true');
    setIsVisible(false);
  }, []);

  return { isVisible, dismiss };
}
